<nz-divider></nz-divider>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="inspectionApprovalGroup">
  <div nz-row>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item class="ml-lg">
        <nz-form-label nzRequired>{{'app.label.inspection.riskType' | translate }}</nz-form-label>
        <nz-form-control [nzErrorTip]="'Risk Type is Required'">
          <nz-select required nzPlaceHolder="Risk Type"  id="riskType" formControlName="riskType" (ngModelChange)="onRiskTypeChanges($event)">
            <nz-option *ngFor="let is of riskTypeList" [nzValue]="is.code" [nzLabel]="is.label"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>  
    

  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired>Inspection From & Inspection To </nz-form-label>
      <nz-form-control [nzErrorTip]="'Inspection From & Inspection To is Required'">
        <nz-range-picker required class="w-auto" [nzShowTime]="{ nzFormat: 'HH:mm'  }" [nzPlaceHolder]="['Inspection From', 'Inspection To']" id="timeRange" formControlName="timeRange"></nz-range-picker>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired>{{'app.label.inspection.status' | translate }}</nz-form-label>
      <nz-form-control [nzErrorTip]="'Inspection Status is Required'">
        <nz-select required nzPlaceHolder="Inspection Status"  id="inspectionStatus" formControlName="inspectionStatus" (ngModelChange)="inspectionStatusChange($event)">
          <nz-option *ngFor="let is of inspectionStatusList" [nzValue]="is.label" [nzLabel]="is.label"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="showrejectionReason">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired> Rejection Reason
        <span nz-tooltip nzTitle="Rejection Reason">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Rejection Reason is Required'">
        <nz-select required [nzPlaceHolder]="'Rejection Reason'" id="rejectionReason" formControlName="rejectionReason">
          <nz-option *ngFor="let fa of rejectionReasonList" [nzLabel]="fa.label" [nzValue]="fa.label"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="showActionType">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired> Action Type
        <span nz-tooltip nzTitle="Action Type">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Action Type is Required'">
        <nz-select required [nzPlaceHolder]="'Action Type'" id="actionType" formControlName="actionType">
          <nz-option *ngFor="let fa of actionTypeList" [nzLabel]="fa.label" [nzValue]="fa.label"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="showReferDepartment">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired> Department 
        <span nz-tooltip nzTitle="Department">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Department is Required'">
        <nz-select required [nzPlaceHolder]="'Department'" id="referDepartment" formControlName="referDepartment">
          <nz-option *ngFor="let fa of referDepartmentList" [nzLabel]="fa.label" [nzValue]="fa.code"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>



  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="ml-lg">
      <nz-form-label> Remarks
        <span nz-tooltip nzTitle="Remarks">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Remarks is Required'">
        <textarea rows="2" id="remarks" formControlName="remarks" nz-input></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24" *ngIf="newRiskFound">
      <div class="float-left">
        
        <button nz-button type="button" nzType="primary" id="addFeedback"  (click)="openFeedbackDrawer()"
                class=" btnStyle text-right"><i nz-icon nzType="plus-circle" nzTheme="outline"></i> Add Feedback</button>
      </div>
  </div>
  
  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24" *ngIf="newRiskFound">
    <nz-table #basicTable [nzData]="riskFeedbackList" [nzShowPagination]="false" class="mt-lg clear-both">
      <thead>
        <tr>
          <th nzWidth="70px">{{ 'app.label.inspection.feedback' | translate }}</th>
          <th nzWidth="70px">{{'app.label.inspection.risk.area' | translate}}</th>
          <th nzWidth="70px">{{ 'app.label.inspection.priority' | translate }}</th>
          <th nzWidth="70px">{{ 'app.label.inspection.severity' | translate }}</th>
          <th nzWidth="70px">{{ 'app.label.inspection.significance' | translate }}</th>
          <th nzWidth="70px">{{ 'app.label.inspection.action' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of basicTable.data; let idx = index">
          <td>{{row.name }}</td>
          <td>{{row.riskArea }}</td>
          <td>{{row.priority}}</td>
          <td>{{row.severity}}</td>
          <td>{{row.significance}}</td>
          
          <td nzRight="0px">
            <a nz-button nz-dropdown [nzDropdownMenu]="menu">
              <i nz-icon nzType="more" nzTheme="outline"></i>
            </a>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <li nz-menu-item>
                  <a (click)="editFeedback(idx);">
                    <i nz-icon nzTheme="outline" nzType="edit"></i>
                    {{'ums.um.update' | translate}}</a>
                </li>
                <li nz-menu-item>
                  <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="ok" nzCancelText="cancel"
                    (nzOnConfirm)="deleteFeedback(idx)" (nzOnCancel)="cancel()">
                    <i nz-icon nzTheme="outline" nzType="delete"></i>
                    {{'ums.um.delete' | translate}}</a>
                </li>
              </ul>
            </nz-dropdown-menu>
          </td>
          <ng-template #noItm></ng-template>
        </tr>
      </tbody>
    </nz-table>
   </div>
   <br>
   <br>
   <nz-divider></nz-divider>
  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button nz-button id="btnPreview" class="mr-lg" [disabled]="!referenceNumber"
        *ngIf="!(this.cType == 'notInspection' || cType !== 'PI')" (click)="onOpenRiskAssesmentReport()">
        <i nz-icon nzType="plus-circle" nzTheme="outline"></i>Risk Assesment Report
      </button>
      <button nz-button (click)="onSubmit()">{{ this.submitBtnName }}</button>
    </div>
  </div>
</div>
</form>
